import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VesselViewComponent } from './vessel-view.component';

const routes: Routes = [
  {
    path: '',
    component: VesselViewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VesselViewRoutingModule {}
